import * as Actions from './types';
import {
  addAppointmentApi,
  updateAppointmentApi,
  getAppointmentsApi,
  getAppointmentApi,
} from '../../api/appointments/appointments-api';

export const addAppointment = (appointmentData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.ADD_APPOINTMENT_REQUEST,
    });

    const { data } = await addAppointmentApi(appointmentData);

    dispatch({
      type: Actions.ADD_APPOINTMENT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.ADD_APPOINTMENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const updateAppointment =
  (appointmentData, isDeleted = false) =>
  async (dispatch) => {
    try {
      dispatch({
        type: Actions.UPDATE_APPOINTMENT_REQUEST,
        payload: { isDeleted },
      });

      const { data } = await updateAppointmentApi(appointmentData);

      dispatch({
        type: Actions.UPDATE_APPOINTMENT_SUCCESS,
        payload: data,
      });
    } catch (error) {
      dispatch({
        type: Actions.UPDATE_APPOINTMENT_FAIL,
        payload:
          error.response && error.response.data.message
            ? error.response.data.message
            : error.message,
      });
    }
  };

export const getAppointments = (appointmentData) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_APPOINTMENTS_REQUEST,
    });
    const { data } = await getAppointmentsApi(appointmentData);
    dispatch({
      type: Actions.GET_APPOINTMENTS_SUCCESS,
      payload: data.appointments || [],
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_APPOINTMENTS_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};

export const getAppointment = (id) => async (dispatch) => {
  try {
    dispatch({
      type: Actions.GET_APPOINTMENT_REQUEST,
    });
    const { data } = await getAppointmentApi(id);
    dispatch({
      type: Actions.GET_APPOINTMENT_SUCCESS,
      payload: data,
    });
  } catch (error) {
    dispatch({
      type: Actions.GET_APPOINTMENT_FAIL,
      payload:
        error.response && error.response.data.message
          ? error.response.data.message
          : error.message,
    });
  }
};
